/*
  This script saves info about the witch customer last viewed products, and save data in localStorage(DATA_KEY).
  You can use this data to show the customer his last viewed products.

  Use [data-last-viewed-count="5"] to set how many products to save (default is 10).
  To show last viewed products, you can use the section "last-viewed-products" in your theme.

  How to use:
  Add this script on the product page

  Note: This script requires a DOM element with id "data-product-json" containing JSON data about the product.
  Example:
  <script type="application/json" id="data-product-json">
    {{ product | json }}
  </script>
* */

class SaveLastProducts {
  constructor() {
    this.constants = {
      DATA_KEY: 'data_last_viewed_products',
      MAX_PRODUCTS: document.querySelector('[data-last-viewed-count]') ?
        Number(document.querySelector('[data-last-viewed-count]').dataset.lastViewedCount) : 10
    };

    this.storageData = this.dataFromStorage;
    this.productData = this.productJsonData;
  }

  /**
   Retrieves and parses JSON data about the product from the DOM element with id data-product-json.
   @returns {{handle: string}|null} Object containing product information or null if data is not found.
 */
  get productJsonData() {
    const data = document.querySelector('#data-product-json');

    if (!data) {
      console.warn('Product JSON data not found.');
      return null;
    }

    return this.parseProductData(JSON.parse(data.innerText));
  }

  parseProductData = (data) => {
    if (!data) return [];

    return {
      handle: data.handle
    };
  };

  get dataFromStorage() {
    const data = localStorage.getItem(this.constants.DATA_KEY);

    if (!data) {
      localStorage.setItem(this.constants.DATA_KEY, '[]');
      return [];
    }

    return JSON.parse(data);
  }

  /**
   * Saves information about the last viewed product to localStorage.
   * @param {{handle: string}} value - Object containing product information. The `handle` property is required.
   * @returns {Array} Updated array of last viewed products.
   */
  saveDataToStorage(value) {
    const { MAX_PRODUCTS, DATA_KEY } = this.constants;
    let currentData = this.storageData.filter(item => item['handle'] !== value.handle);

    if (currentData.length >= MAX_PRODUCTS) {
      currentData = currentData.slice(0, MAX_PRODUCTS - 1);
    }

    currentData.unshift(value);
    localStorage.setItem(DATA_KEY, JSON.stringify(currentData));

    this.storageData = currentData;

    return currentData
  }

  render = () => {
    if (!this.productData) return;


    this.saveDataToStorage(this.productData)
  };
}

new SaveLastProducts().render();